"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HourInput = void 0;
var React = require("react");
var HourInput = /** @class */ (function (_super) {
    __extends(HourInput, _super);
    function HourInput(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { focused: false, inputValue: _this.props.value };
        return _this;
    }
    HourInput.prototype.fireHourChange = function (event) {
        var value = event.target.value;
        if (/^[0-9.,]+$/.test(value) || value === '') {
            this.setState({
                inputValue: value.includes('.') ? value.match(/^-?\d+(?:\.\d{0,2})?/)[0] : value
            });
        }
    };
    HourInput.prototype.displayFormattedHour = function () {
        if (this.props.displayFormat) {
            return this.props.displayFormat(this.props.value);
        }
        // Default
        return this.props.value;
    };
    HourInput.prototype.componentDidUpdate = function () {
        if (this.state.focused) {
            this.input.focus(); // Need to focus after rendered
        }
    };
    HourInput.prototype.onBlur = function () {
        var value = this.input.value.replace(/,/g, '.');
        this.input.value = value ? parseFloat(value) : '';
        this.setState({ focused: false, inputValue: this.input.value });
        this.props.onChange(this.input);
    };
    HourInput.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "hour-input-wrapper" },
            React.createElement("span", { className: 'clickable ' + (this.state.focused ? 'hidden' : ''), onClick: function () { if (!_this.props.disabled) {
                    _this.setState({ focused: true });
                } } }, this.displayFormattedHour()),
            React.createElement("input", { ref: function (ref) { return _this.input = ref; }, className: 'without-ampm hour-input ' + (!this.state.focused ? 'hidden' : ''), name: this.props.name, min: 0, onBlur: function () { return _this.onBlur(); }, type: 'text', disabled: this.props.disabled || false, onChange: function (event) { return _this.fireHourChange(event); }, value: this.state.inputValue, required: this.props.required })));
    };
    return HourInput;
}(React.Component));
exports.HourInput = HourInput;
